import React, { useState, useEffect } from "react";
import { IonLoading } from "@ionic/react";

const Loading = () => {
	return (
		<IonLoading
			// cssClass="my-custom-class"
			isOpen={true}
			// onDidDismiss={() => setIsLoading(false)}
			message={"Please wait. Loading..."}
			// duration={5000}
			spinner="crescent"
		/>
	);
};

export default Loading;
